import { jsx as _jsx } from "react/jsx-runtime";
import { useSearchParams } from 'react-router-dom';
import { AppError } from '@client/components/feedback/AppError';
export const AuthCallback = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const error = searchParams.get('error');
    const errorDescr = searchParams.get('error_description');
    if (error) {
        return (_jsx(AppError, { title: "Login failed", content: errorDescr || '' }));
    }
    return null;
};
